"use strict";
/* eslint-disable @typescript-eslint/no-namespace */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeGenConnectionType = void 0;
/**
 * Field-level Relationship Definitions
 */
var CodeGenConnectionType;
(function (CodeGenConnectionType) {
    CodeGenConnectionType["HAS_ONE"] = "HAS_ONE";
    CodeGenConnectionType["BELONGS_TO"] = "BELONGS_TO";
    CodeGenConnectionType["HAS_MANY"] = "HAS_MANY";
})(CodeGenConnectionType || (exports.CodeGenConnectionType = CodeGenConnectionType = {}));
